// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileGifOutlinedSvg from "@ant-design/icons-svg/es/asn/FileGifOutlined";
import AntdIcon from '../components/AntdIcon';

var FileGifOutlined = function FileGifOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileGifOutlinedSvg
  }));
};

FileGifOutlined.displayName = 'FileGifOutlined';
export default React.forwardRef(FileGifOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileGifOutlined.js
// module id = 1107
// module chunks = 0